import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ProveedoresListComponent } from './proveedores-list/proveedores-list.component';
import { ProveedoresCreateComponent } from './proveedores-create/proveedores-create.component';



const routes: Routes = [

    { path: '', component: ProveedoresListComponent  },
    { path: 'edit/:id', component: ProveedoresCreateComponent },
    { path: 'crear', component: ProveedoresCreateComponent }, 
    
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class AppProveedoresRoutingModule {}
